import React from 'react'
import LayoutMain from "../../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";


const leftSidedImageCopyItemCollectionData = [
    {
        description : [
            'This small courtyard was transformed from an ugly rundown mess into a peaceful and intimate oasis. Faced with the challenge of an area no bigger than 3 x 5m, a custom made floating concrete bench flows from inside to out maximising space for entertaining. Layers of contrasting tropical planting provide a lush green backdrop - a true urban jungle. A burst of unexpected yellow in furnishings, careful selection of feature plants in contemporary pots and the addition of a giant clam shell complete the space and add to its fresh modern appeal.',
        ],
        descriptionContent : (
          <p>
          <span className="line">
          <b>Services Undertaken</b>
          <br />Landscape Architecture
          <br />Construction
          <br />Ongoing Maintenance
          </span>
          
          <b>Design Features</b>
          <br />Contemporary
          <br />Entertainer
          <br />Courtyard/Rooftop
          </p>
        ),
        image : '../images/projects/paddington-5.jpg',
        title : 'Paddington'
    }
]

const projectImageDetailPageCollectionData = [
    {
        dataId : 'a1',
        image : '../images/projects/paddington-1.jpg'
    },
    {
        dataId : 'a3',
        image : '../images/projects/paddington-5.jpg'
    },
    {
        dataId : 'a4',
        image : '../images/projects/paddington-4.jpg'
    },
    {
        dataId : 'a2',
        image : '../images/projects/paddington-3.jpg'
    },
    {
        dataId : 'a5',
        image : '../images/projects/paddington-6.jpg'
    },
    {
        dataId : 'a8',
        image : '../images/projects/paddington-2.jpg'
    },
]

const PagePaddington = () => {
  return (
    <LayoutMain>
          <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton />
        </LayoutMain>
  )
}

export default PagePaddington